<template>
  <div class="channels-tabs">
    <h2>Выбирайте удобный для&nbsp;вас канал&nbsp;связи</h2>
    <VTabsWithAnimationMTS>
      <VTabMTS
        v-for="(tab, index) in tabList"
        :key="tab.id"
        :name="tab.name"
        :selected="index === 0"
      >
        <FaqAndSupportChannelsTabContent :tab="tab.content" />
      </VTabMTS>
    </VTabsWithAnimationMTS>
  </div>
</template>

<script>
import VTabsWithAnimationMTS from '@/components/Common/MTS/VTabsWithAnimationMTS.vue'
import VTabMTS from '@/components/Common/MTS/VTabMTS.vue'
import FaqAndSupportChannelsTabContent from '@/components/Desktop/FaqAndSupport/Channels/FaqAndSupportChannelsTabContent.vue'
import FaqAndSupportChannelsMixin from '@/components/Desktop/FaqAndSupport/mixins/FaqAndSupportChannelsMixin'

export default {
  name: 'FaqAndSupportChannelsTabs',
  components: {
    FaqAndSupportChannelsTabContent,
    VTabMTS,
    VTabsWithAnimationMTS,
  },
  mixins: [FaqAndSupportChannelsMixin],
}
</script>

<style scoped lang="scss">
.channels-tabs {
  padding: 32px 0 64px;
  color: $color-dark-2;

  h2 {
    margin-bottom: 20px;
    font-family: $font-mts-wide;
    font-size: 36px;
    line-height: 40px;
    font-weight: 500;
    letter-spacing: -0.01em;

    @include screen-down('md') {
      max-width: 400px;
      font-size: 32px;
      line-height: 38px;
    }
  }

  &::v-deep .v-tabs-mts {
    margin: 0;
  }
}
</style>
